import {
  UnitBreakDownRateStateTypes,
  UnitBreakDownRateActionTypes,
} from "./UnitBreakDownRate.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: UnitBreakDownRateStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const UnitBreakDownRateReducer = (
  state: UnitBreakDownRateStateTypes = INITIAL_STATE,
  action: any
): UnitBreakDownRateStateTypes => {
  switch (action.type) {
    case UnitBreakDownRateActionTypes.FETCH_ALL_UNIT_BREAKDOWN_RATE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case UnitBreakDownRateActionTypes.FETCH_ALL_UNIT_BREAKDOWN_RATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case UnitBreakDownRateActionTypes.FETCH_ALL_UNIT_BREAKDOWN_RATE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UnitBreakDownRateActionTypes.FETCH_ALL_UNIT_BREAKDOWN_RATE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case UnitBreakDownRateActionTypes.FETCH_ONE_UNIT_BREAKDOWN_RATE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case UnitBreakDownRateActionTypes.FETCH_ONE_UNIT_BREAKDOWN_RATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case UnitBreakDownRateActionTypes.FETCH_ONE_UNIT_BREAKDOWN_RATE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UnitBreakDownRateActionTypes.FETCH_ONE_UNIT_BREAKDOWN_RATE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default UnitBreakDownRateReducer;
